<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="fill-current inline-block" :class="[width, height]" viewBox="0 0 9 67">
    <g id="route" transform="translate(-23 -444)">
      <circle
        id="Ellipse_177"
        data-name="Ellipse 177"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(23 444)"
        fill="#f0324c"
      />
      <g
        id="Ellipse_178"
        data-name="Ellipse 178"
        transform="translate(23 502)"
        fill="#fff"
        stroke="#62eb77"
        stroke-width="2"
      >
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
        <circle cx="4.5" cy="4.5" r="3.5" fill="none" />
      </g>
      <rect
        id="Rectangle_605"
        data-name="Rectangle 605"
        width="3"
        height="3"
        rx="1.5"
        transform="translate(26 463)"
        fill="#2f3042"
      />
      <rect
        id="Rectangle_607"
        data-name="Rectangle 607"
        width="3"
        height="3"
        rx="1.5"
        transform="translate(26 476)"
        fill="#2f3042"
      />
      <rect
        id="Rectangle_608"
        data-name="Rectangle 608"
        width="3"
        height="3"
        rx="1.5"
        transform="translate(26 489)"
        fill="#2f3042"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-2'
    },
    height: {
      type: String,
      default: 'h-16'
    }
  }
}
</script>
